export default __webpack_public_path__ + "static/media/ic_telegram.29120015.svg";